import React, { useState } from 'react'
import 'dayjs/locale/zh-cn'
import { Calendar } from '@mantine/dates'
import dayjs from 'dayjs'
import { useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'

// 当前日期样式
const currentDateStyle = {
  border: '1px solid var(--ow-color-primary-600)',
  borderRadius: '100px',
}

// 选中日期样式
const selectDateStyle = {
  backgroundColor: 'var(--ow-color-primary-600)',
  color: '#fff',
  borderRadius: '100px',
}

const CustomCalendar = function ({ onSelect, reset = true }) {
  const [selectDate, setSelectDate] = useState(new Date())

  const { setFilters } = useTbViewStore((state) =>
    pick(state, ['setFilters', 'tbId', 'tbData'])
  )

  // 设置当前日期应该显示的样式
  const setStyle = (date) => {
    const isCurrentDate =
      date.getMonth() === dayjs().month() && date.getDate() === dayjs().date()

    const isSelectDate =
      date.getMonth() === selectDate.getMonth() &&
      date.getDate() === selectDate.getDate()

    if (isSelectDate) {
      return selectDateStyle
    }

    if (isCurrentDate) {
      return currentDateStyle
    }
    return null
  }

  const searchDate = (value) => {
    const queries = {
      logicType: 'and',
      queries: [
        {
          slug: 'dayStartTime',
          value: `${dayjs(value).format('YYYY/MM/DD')} 00:00:00`,
          queryType: ['dayEqual'],
        },
      ],
    }
    setFilters(queries, reset)
  }

  return (
    <div className="py-4 md:py-0 md:px-2 md:border-b flex items-center justify-center overflow-auto h-full">
      <Calendar
        locale="zh-cn"
        fullWidth
        dayStyle={(date) => {
          return setStyle(date)
        }}
        onChange={(value) => {
          searchDate(value)
          setSelectDate(value)
          if (onSelect) {
            onSelect(value)
          }
        }}
        styles={() => ({
          monthPickerControlActive: {
            background: 'var(--ow-color-primary-700) !important',
          },
          yearPickerControlActive: {
            background: 'var(--ow-color-primary-700) !important',
          },
          day: {
            width: '38px',
            height: '38px',
          },
          cell: {
            padding: '4px',
          },
        })}
      />
    </div>
  )
}

export default CustomCalendar
